<template>
    <v-card class="statisticsDonutComponent pa-3 pt-0">
        <v-card-title>
            <!-- {{ $t("events_list") }} -->
            {{ $t(titleTable) }}
            <v-btn v-if="utmType && nbUnknown > 0" class="ml-6" color="pink" :loading="loadingButton" dark depressed @click="showMappingUnknownModal">{{ $tc('unknown_' + utmType + '_count', nbUnknown, { count: nbUnknown }) }}</v-btn>
            <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text>
            <DatatableV2 v-if="datatableKey > 0" 
                :displayTitle="true" 
                :key="datatableKey" 
                :flat="true" :url="apiUrl" 
                :prefilters="filters" 
                :forceItemsPerPage="5" 
                :disableSaveParams="true"
                @exportData="exportData" />
        </v-card-text>

        <v-dialog persistent width="400" v-model="showDownload">
            <v-card>
                <v-card-text class="pa-6">
                    <h5 class="icon-title">
                        {{ $t('downloadReady') }}
                        <v-btn @click="showDownload = false" text class="square">
                            <v-icon small>$close</v-icon>
                        </v-btn>
                    </h5>
                    <div class="text-center mt-4 mb-2">
                        <a :href="downloadUrl" @click="showDownload = false" download class="exportBtn">{{$t('clickForDownload')}}</a>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>

        <FormDialogComponent v-if="form" ref="componentForm" :form="form" :action="'SET_DATA'" />
    </v-card>
</template>

<script>
import GenericDataService from '@/services/GenericDataService';
import DatatableV2 from '@/components/DatatableV2';
import getForm from '@/mixins/mixins';

export default {
    name: "statisticsEventsListComponent",
    props: ["filters", "titleTable", "dataUrl", "exportUrl", "utmType"],
    mixins: [getForm],
    components: { 
        FormDialogComponent: () => import("@/components/dialogs/FormDialogComponent"), 
        DatatableV2, 
    },
    data() {
        return {
            api: this.$store.state.auth.apiUrl,
            datatableKey: 0,
            downloadUrl: '',
            showDownload: false,
            nbUnknown: 0,
            loadingButton: false,
            mappingUnknownModal: false,
            form: null,
        }
    },
    computed: {
        apiUrl() {
            return `/stats/${this.dataUrl}`;
        },
    },
    watch: {
        filters: {
            handler(newFilters) {
                this.datatableKey++;
                if(this.utmType)
                    this.getNbUnknownUtms();
            },
            deep: true
        },
        form: {
            handler(newForm) {
                this.loadingButton = false;
            }
        },
    },
    methods: {
        exportData(params) {
            let payload = {};
            payload.filters = this.filters;

            GenericDataService.postData(params.url, payload).then((response) => {
                if(response.data.data.directDownload) {
                    this.downloadUrl = this.api + response.data.data.directDownload;
                    this.showDownload = true;
                }
            });
        },
        getNbUnknownUtms() {
            GenericDataService.postData('/stats/getNbUnknownUtms?type=' + this.utmType, { filters: this.filters }).then((response) => {
                this.nbUnknown = response.data.data;
            });
        },
        showMappingUnknownModal() {
            this.loadingButton = true;
            this.getForm('/stats/getUnknownUtmsMapping?type=' + this.utmType, this.filters, false, null, null, true, true);
        },
        customRefresh() {
            this.datatableKey++;
            this.getNbUnknownUtms();
        },
    },
}
</script>